import React, {Component} from "react"
import {Container, Divider, Form, Header, Loader} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {setDependents, setMaritalStatus} from "../actions/userActions";
import {connect} from "react-redux";
import {getLocalization, parseMultilineString} from "../utils/localization";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, getStepProps, handleSaveUserProgress, isAnsel, isSymetra, languages, getSpouseEligibilityString} from "../utils/common";
import {isRenaissanceLouisiana} from "../utils/renaissanceLouisiana";
import Steps from "./steps/steps";
import Footer from "./footer";
import {CustomGrid} from "./custom-common";

const mapStateToProps = (state, ownProps) => {
    const {user, benAdmin, initialData} = state;
    return {
        user, initialData, benAdmin,
        maritalStatusOptions: initialData.maritalStatusOptions,
        dependentsOptions: initialData.dependentsOptions,
        lang: user.lang,
        dependents: user.dependents,
        maritalStatus: user.maritalStatus,
        domesticPartnerEligible: initialData.eligibility.domesticPartnerEligible,
        civilUnionEligible: initialData.eligibility.civilUnionEligible,
        ...ownProps
    }
};

class TellUsAboutYou extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            needsUserProgressUpdate: false,
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    handleMaritalStatusChange = (event, {value}) => {
        const {dispatch} = this.props;
        this.setState({needsUserProgressUpdate: true});
        dispatch(setMaritalStatus(value));
    };

    handleDependentsChange = (event, {value}) => {
        const {dispatch} = this.props;
        this.setState({needsUserProgressUpdate: true});
        dispatch(setDependents(value));
    };

    render() {
        const {stepProps, needsUserProgressUpdate} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }
        const {maritalStatusOptions, dependentsOptions, dependents, user, domesticPartnerEligible, civilUnionEligible, initialData} = this.props;

        const localization = getLocalization(this.props.lang);
        const strings = localization.tellUsAboutYou;

        const maritalStatusOpts = maritalStatusOptions.map((o) => {
            return {key: o.id, value: o.id, text: o.value};
        });

        const dependentsOpts = dependentsOptions.map((o) => {
            return {key: o.id, value: o.id, text: o.value};
        });

        const renaissanceLouisiana = isRenaissanceLouisiana(initialData);
        const defaultMaritalStatusClarification = getSpouseEligibilityString(domesticPartnerEligible, civilUnionEligible, strings);
        const maritalStatusClarification = renaissanceLouisiana && defaultMaritalStatusClarification
            ? strings.partnerClarificationLouisiana
            : defaultMaritalStatusClarification;
        const maritalStatusQuestion = renaissanceLouisiana ? strings.maritalStatusLouisiana : strings.maritalStatus;

        return (
            <React.Fragment>
                <Container className={isSymetra() && 'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid columns={1}>
                                <CustomGrid.Row>
                                    <CustomGrid.Column>
                                        <Header as='h2'>{strings.title}</Header>
                                        <p>{parseMultilineString(strings.description)}</p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                                <CustomGrid.Row>
                                    <CustomGrid.Column>
                                        <Form>
                                            <p><b className={"requiredField"}>{maritalStatusQuestion}</b><br/>
                                            {maritalStatusClarification && <span style={{fontSize: '14px'}}>{maritalStatusClarification}</span>}
                                            </p>
                                            <Form.Field>
                                                <Form.Group grouped>
                                                    {maritalStatusOpts.map((ms) => {
                                                        let text = ms.text;
                                                        const localizationEng = getLocalization(languages.ENGLISH);
                                                        const engStrings = localizationEng.tellUsAboutYou;
                                                        if(text === engStrings.yes){
                                                            text = strings.yes;
                                                        } else if(text === engStrings.no){
                                                            text = strings.no;
                                                        }
                                                        return <Form.Radio
                                                            key={ms.key}
                                                            label={text}
                                                            value={ms.value}
                                                            checked={this.props.maritalStatus === ms.value}
                                                            onChange={this.handleMaritalStatusChange}
                                                        />
                                                    })}
                                                </Form.Group>
                                            </Form.Field>
                                            <Divider hidden/>
                                            <p className={"requiredField"}><b>{strings.dependents}</b></p>
                                            <Form.Field inline>
                                                <Form.Group grouped>
                                                    {dependentsOpts.map((d) => {
                                                        let text = d.text;
                                                        const localizationEng = getLocalization(languages.ENGLISH);
                                                        const engStrings = localizationEng.tellUsAboutYou;
                                                        if(text === engStrings.noKids){
                                                            text = strings.noKids;
                                                        } else if(text === engStrings.aKid){
                                                            text = strings.aKid;
                                                        } else if(text === engStrings.aKidGrown){
                                                            text = strings.aKidGrown;
                                                        }

                                                        return <Form.Radio
                                                            key={d.key}
                                                            label={text}
                                                            value={d.value}
                                                            checked={dependents === d.value}
                                                            onChange={this.handleDependentsChange}
                                                        />
                                                    })}
                                                </Form.Group>
                                            </Form.Field>
                                        </Form>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => {
                        if(needsUserProgressUpdate){
                            handleSaveUserProgress(initialData.token, user).then();
                        }
                        this.props.history.push(this.props.nextRoute);
                    }}
                    disabled={!this.props.dependents || !this.props.maritalStatus}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(TellUsAboutYou));
